import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-heading">Xerowrite</h3>
            <p className="footer-text">
              The highest-performing direct mail postcard, with exclusive variable fluorescent pink highlighter. Many millions of pieces mailed. Serving all 50 states from St. George, Utah.
            </p>
          </div>

          <div className="footer-section">
            <h3 className="footer-heading">Contact</h3>
            <div className="footer-contact">
              <a href="tel:8015097884" className="footer-contact-item">
                <Phone size={18} />
                <span>801.509.7884</span>
              </a>
              <a href="mailto:mail@xerowrite.com" className="footer-contact-item">
                <Mail size={18} />
                <span>mail@xerowrite.com</span>
              </a>
              <div className="footer-contact-item">
                <MapPin size={18} />
                <span>1575 S River Rd.<br />St. George, UT 84790</span>
              </div>
              <div className="footer-contact-item">
                <Clock size={18} />
                <span>Monday–Friday<br />9:00am to 5:30pm MT</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>
            <nav className="footer-nav">
              <a href="/product" className="footer-nav-link">The Product</a>
              <a href="/about" className="footer-nav-link">About & Contact</a>
            </nav>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} Xerowrite. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
